exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Styles used in PageOne.jsx  */\n\n.header-color{\n    background-color:#808080;\n    white-space: normal\n}\n", ""]);

// exports
